import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=66a0426f&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=66a0426f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0426f",
  null
  
)

export default component.exports